export default "__VITE_ASSET__D75YdVag__"